import React, { useState, useEffect, useRef } from "react";
import { formatMoneda } from "../../../util/varios";
import useTableFijo from "../../useTableFijo";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
import { Input, SearchInput } from "../../../ui/inputs/Input";
const headCells = [
  {
    id: "idfactura",
    label: "N° DE PAGO",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "fechaenterami",
    label: "FECHA PAGO",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "periodo",
    label: "CONCEPTO",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "numrete",
    label: "REFERENCIA",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "numrete",
    label: "BANCO DESTINO",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "numrete",
    label: "MONTO",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];
const TablaOtrosPagosEtax = (props) => {
  const [titulo] = useState();
  const [msg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [activate, setActivate] = useState(false);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    320
  );
  const txtFecha = useRef();
  const handleSearch = (e) => {
    let target = e.target;
    let fechaFiltro = moment.utc(txtFecha.current.value).format("YYYY-MM-DD");
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            let fechaPago = moment.utc(x.fecha_pago).format("YYYY-MM-DD");
            let result = moment.utc(fechaPago).isBefore(fechaFiltro);
            if (
              result &&
              (moment.utc(fechaPago).format("DD/MM/YYYY").includes(target.value) ||
                x.concepto.toLowerCase().includes(target.value.toLowerCase()) ||
                x.referencia_banco
                  .toString()
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                formatMoneda(
                  x.monto.toString().replace(".", ","),
                  ",",
                  ".",
                  2
                ).includes(target.value) ||
                x.bancodestino.includes(target.value))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    if (props.tabreten) {
      setRecords(props.tabreten);
    }
    txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
  }, [props.tabreten]);
  const handleCloseNo = () => {
    setMostrar3(false);
  };
  const handleCloseSi = () => {
    setMostrar3(false);
    setActivate(true);
  };
  const handleCloseMensa = () => {
    setMostrar(false);
  };
  return (
    <div className="card">
        <div className="col-12 m-0 my-2 p-0 d-flex">
            <div className = 'col-3 m-0 p-0'>
            <SearchInput
                placeholder="Buscar"
                onChange={handleSearch}
            />
            </div>
            <div className = 'col-3 m-0 p-0 pl-2'>
            <Input
                label="Fecha:"
                type="date"
                ref={txtFecha}
                defaultValue={moment.utc(fechaSistema).format("YYYY-MM-DD")}
            />
            </div>
        </div>
        <div className="col-12 m-0 p-0">
        <TblContainer
            container={{
            height: 250,
            width: "100%",
            overflow: "auto",
            padding: "2px",
            }}
        >
            <TblHead />
            <tbody>
            {records &&
                records.map((item, index) => (
                <tr
                    key={item.idfactura + item.periodo}
                    style={{ padding: "0" }}
                >
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.numero}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {moment.utc(item.fecha_pago).format("DD/MM/YYYY")}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "left" }}>
                    {item.concepto}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.referencia_banco}
                    </td>
                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.bancodestino}
                    </td>

                    <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {formatMoneda(
                        item.monto.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                    )}
                    </td>
                </tr>
                ))}
            </tbody>
        </TblContainer>
        </div>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />

      <MensajeSiNo
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaOtrosPagosEtax;
